const api_key = 'iwKLN8NqoEeSDQOQ2VyjQ'
export const url = `https://egg.afisha.ru/v1/event/commonV2?api_key=${api_key}`

export const pageNameMapping = {
  app_home: 'main',
  rest_item: 'rest_card',
  rest_reviews: 'rest_reviews',
  rests_listing: 'restaurant_list',
  search_rests_listing: 'search_result',
  news_gallery: 'main_news',
  news_item: 'article',
  selections_gallery: 'selection_list',
  selection_item: 'selection_card',
  reserve: 'reserve',
  success: 'success',
}
